// CONSTANTS are all caps.
const NS = 'ContentCarouselBlock';
const CLS = 'contentCarouselBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/portalProfileDropdown.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class ContentCarouselBlock {
	constructor($el) {
		// $el is the widget node return by the ContentCarouselBlock function
		this.$el = $($el);
		this.$html = $('html');
	}

	init() {
		$(`${BLK}slider`).slick({
			fade: true,
			dots: true,
			arrows: true,
			infinite: true,
			asNavFor: `${BLK}asideSlider`,
			dotsClass: `${CLS}-sliderDots`,
			nextArrow: $(`${BLK}sliderNext`),
			prevArrow: $(`${BLK}sliderPrev`),
			appendDots: $(`${BLK}sliderDotsAppend`),
		});

		$(`${BLK}asideSlider`).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			asNavFor: `${BLK}slider`,
		});
	}
}
